import React, { useState, useEffect } from 'react';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { Form, Modal, Input } from 'antd';
import { NotificationInstance } from 'antd/lib/notification/interface';

import { useAppDispatch } from '@store/hooks';

import PhoneInputFormItem from '@controls/phone-input-form-item/phone-input-form-item';
import IBaseComponentProps from '@components/base-component-props';

import { exception } from '@extensions/notification';
import { userLoaded } from '@store/actions';

import { IUser } from '@entities/user';
import { IUserCallLog } from '@entities/user-call-log';

dayjs.extend(utc);

interface ICallLogModalProps extends IBaseComponentProps {
    userId: string;
    onSave: () => void;
    onCancel: () => void;
    api: NotificationInstance;
}

const CallLogModal = (props: ICallLogModalProps) => {
    const { userId, api, onSave, onCancel, serverFetch } = props;

    const { TextArea } = Input;

    const d = useAppDispatch();

    const [form] = Form.useForm();

    const [user, setUser] = useState<IUser>();

    const [refreshRequired, setRefreshRequired] = useState<boolean>(true);

    useEffect(() => {
        let cleanup = false;

        if (!refreshRequired) return;

        const fetchData = async () => {
            const promises = [
                await serverFetch(`users/${userId}`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения пользователя', ex, () => d(userLoaded(undefined)));
                    }),
            ];

            Promise.all([promises]).then((result) => {
                if (cleanup) return;

                setUser(result[0][0]);

                form.setFieldsValue({
                    userId: userId,
                });

                setRefreshRequired(false);
            });
        };

        fetchData();

        return () => {
            cleanup = true;
        };
    }, [refreshRequired]);

    const onSaveLog = (entity: IUserCallLog) => {
        serverFetch(`usercalllogs`, { method: 'POST', bodyData: entity })
            .then(() => {
                onSave();
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка сохранения результата звонка', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <Modal
            destroyOnHidden={true}
            width={650}
            title={`Звонок клиенту "${user?.login}"`}
            open={true}
            okText='ОК'
            onOk={() => {
                form.submit();
            }}
            onCancel={() => onCancel()}
        >
            {user && (
                <Form
                    colon={false}
                    labelCol={{ span: 5 }}
                    wrapperCol={{ span: 19 }}
                    style={{ marginTop: 20 }}
                    form={form}
                    onFinish={onSaveLog}
                >
                    <Form.Item hidden name='userId'>
                        <Input />
                    </Form.Item>

                    <Form.Item label='ФИО' name='fullName' initialValue={user.fullName}>
                        <Input disabled={true} />
                    </Form.Item>

                    <PhoneInputFormItem
                        wrapperCol={{ span: 9 }}
                        value={user.phone}
                        name='phone'
                        label='Телефон'
                        disabled={true}
                    />
                    <PhoneInputFormItem
                        wrapperCol={{ span: 9 }}
                        value={user.phone2}
                        name='phone2'
                        label='Телефон 2'
                        disabled={true}
                    />

                    <Form.Item label='Результат' name='comment' required rules={[{ required: true, message: 'Укажите результат звока' }]}>
                        <TextArea rows={6} />
                    </Form.Item>
                </Form>
            )}
        </Modal>
    );
};

export default CallLogModal;
